<template>
    <v-container grid-list-sm>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Gestión del Curso</h3>
                        </div>
                    </v-card-title>
                    <v-list two-line>
                        <template v-for="item in items">
                            <v-list-tile
                                    :key="item.clave"
                                    :href="item.url"
                                    target="_blank"
                                    :disabled="!item.exists"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="item.materia"></v-list-tile-title>
                                    <v-list-tile-sub-title class="text--primary">{{ item.docente }}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>{{ item.clave }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-icon
                                            color="teal"
                                            v-if="item.exists"
                                    >
                                        cloud_download
                                    </v-icon>
                                    <v-icon
                                            color="red"
                                            v-else
                                    >
                                        cloud_download
                                    </v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="250px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span style="max-width: 150px">Buscando archivos de Gestión del Curso</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'BoletaPage',
    data: () => ({
      cargandoDatos: false,
      items: []
    }),
    methods: {
      getInstrumentaciones () {
        this.cargandoDatos = true
        axios.get('alumno/gestion-curso')
          .then(response => {
            this.cargandoDatos = false
            this.items = response.data
          })
      }
    },
    mounted () {
      this.getInstrumentaciones()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/information/GestionCursoPage.vue